class Line{
    period = null; //Periodo
    schedule = null; //Horario
    avaliablePeriods = []; //Periodos disponibles del casal
    duration = null; //Duracion del periodo

    constructor(period, schedule, avaliablePeriods){
        this.period = period;
        this.schedule = schedule;
        this.avaliablePeriods = avaliablePeriods;
        this.duration = this.period.duration;
    }
}

export default Line;